import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Catalog from './canine-u/comp/Catalog';
import Menu from './canine-u/comp/Menu';
import Register from './canine-u/comp/Register';
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter } from 'react-router-dom'
import Schedule from './canine-u/comp/Schedule';
import Faculty from './canine-u/comp/Faculty';
import Map from './canine-u/comp/Map';

import ErrorDialog from './comp/ErrorDialog';
import { Provider } from 'react-redux'
import Store from './redux/Store'

const routes = (
  < BrowserRouter >
     <div>
        <Route exact path="/canine-u" component={App} />
        <Route path="/canine-u/menu" component={Menu} />
        <Route path="/canine-u/catalog" component={Catalog} />
        <Route path="/canine-u/register" component={Register} />
        <Route path="/canine-u/schedule" component={Schedule} />
        <Route path="/canine-u/faculty" component={Faculty} />
        <Route path="/canine-u/map" component={Map} />
        
        <Provider store={Store}>
          <ErrorDialog></ErrorDialog>
        </Provider>
     </div>
  </ BrowserRouter >
);

ReactDOM.render(
  routes,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
